import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { first, map, take } from 'rxjs/operators';
import { CompassAPIExcursionItineraryService } from 'src/app/shared/api-compass/compass-api-excursion-itinerary.service';
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';
import { CompassApiGetResults } from 'src/app/shared/models/compass-api-get-results.interface';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';

import { TravelBoardQuickComponent } from './travel-board-quick/travel-board-quick.component';
import { TravelBoardChooserComponent } from './travel-board-chooser/travel-board-chooser.component';
import { TravelBoardEditComponent } from './travel-board-edit/travel-board-edit.component';
import { TravelBoardResponseComponent } from './travel-board-response/travel-board-response.component';
import * as dayjs from 'dayjs';
import { UserAppAccess } from 'src/app/shared/models/user-app-access.interface';
import { TemplateRef } from '@angular/core';
import { ResponseMessage } from 'src/app/shared/models/response-message.interface';

const _log: boolean = false;


@Component({
	selector: 'app-travel-board',
	templateUrl: './travel-board.component.html'
})
export class TravelBoardComponent implements OnInit {

	modalRef?: BsModalRef;

	public toResize: any;
	public toResizeMs: number = 200;

	public userAppAccess: UserAppAccess;

	constructor(
		private _authHandlerService: AuthHandlerService,
		private _compassAPIExcursionItineraryService: CompassAPIExcursionItineraryService,
		public modalService: BsModalService,
	) { }

	ngOnInit(): void {
		//console.log('TravelBoardComponent.oninit');
		this.userAppAccess = this._authHandlerService.getUserAppAccess();
		//console.log('userAppAccess: ', this.userAppAccess);
	}


	/**
	 * Listen for window resize
	 * @param event 
	*/
	@HostListener('window:resize', ['$event'])
	onResize(event:any) {
		//console.log('Resize', event.target.innerWidth, 'x', event.target.innerHeight);
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.modalRef?.hide();
			if(window.location.hash) this.clearHash();
		}, this.toResizeMs);
	}



	/**
	 * clear hash out of url bar
	*/
	public clearHash() {
		//console.log('TravelBoardQuickComponent.clearHash');
		const winScrollY = window.scrollY;
		window.location.hash = '';
		//window.history.pushState('', '/', window.location.pathname);//removes hash from URL bar, but doesn't actually clear hash
		
		setTimeout(() => {
			window.scroll(0, winScrollY);
		}, 2);//need a moment to allow the router to update first
	}



	//todo-jk: add logic to first check for login

	async onAddToBoard() {
		//console.log('TravelBoardComponent.onAddToBoard.hash:', window.location.hash);

		this.modalRef?.hide();

		const hash = window.location.hash,
			productId = hash.slice(12),
			addToBoardElements = document.querySelectorAll("a[href*='" + hash + "']");

		this.userAppAccess = this._authHandlerService.getUserAppAccess();
		//console.log('TravelBoardComponent.userAppAccess: ', this.userAppAccess);
		// console.log('TravelBoardComponent.onAddToBoard.productId:', productId);
		// console.log('addToBoardElements', addToBoardElements);
		//console.log('userAppAccess', this.userAppAccess);
		
		
		//todo-jk: the following snippet could be better instead of clearing it out, wait for the DOM to load
		//note: this worked fine for home, but not on detail
		if(addToBoardElements.length == 0) {
			this.clearHash();
			return;
		}

		const latestBoard = await this._compassAPIExcursionItineraryService.getLatestBoard(this.userAppAccess.activeAccount.localAccountId)
			.then((res: ExcursionItinerary) => {
				//console.log('latestBoard:', res);
				return res;
			})
			.catch((err) => {
				//console.error('TravelBoardComponent.onAddToBoard.getLatestBoard.err:', err);
				return err;
			});
		//console.log('done awaiting latestBoard call');

		//modal model
		const initialState = {
			productId: productId,
			currentBoard:  latestBoard
		};

		//modal config
		this.modalRef = this.modalService.show(TravelBoardQuickComponent, {
			initialState, 
			animated: false, 
			backdrop: false,
			class: 'travel-board-quick-modal js-travel-board-quick-modal'
		});
		this.modalService.onHide
			.pipe(take(1))
			.subscribe(() => {
				//console.log(this.modalRef.content)
				//console.log('TravelBoardComponent.onHide');
				this.clearHash();
			});

		// (this.modalRef.content as TravelBoardQuickComponent).cancel.subscribe(data=> {
		// 	//console.log('TravelBoardComponent.cancel');
		// 	//this.clearHash();
		// });

		(this.modalRef.content as TravelBoardQuickComponent).selectBoard.subscribe(data=> {
			//console.log('TravelBoardComponent.selectBoard', data);
			//hit select endpoint
			this.addProductToBoard(data.productId, data.board);
		});

		(this.modalRef.content as TravelBoardQuickComponent).chooseBoard.subscribe(data=> {
			//console.log('TravelBoardComponent.chooseBoard', data);
			//open chooser modal
			setTimeout(() => {
				this.onChooseBoard(data.productId);
			}, 1);
		});

		(this.modalRef.content as TravelBoardQuickComponent).createBoard.subscribe(data=> {
			//console.log('TravelBoardComponent.createBoard', data);
			//open create modal
			setTimeout(() => {
				this.onEditBoard(data.productId);
			}, 1);
		});


		//find and position quick modal near productDiv
		if(addToBoardElements.length > 0) {

			//******* todo-jk: note: the code below is good for homepage, but fails on detail page. need to switch it to just track the CTA position and place it off of that. then i don't need to worry about parent/**

			const ctaDiv = addToBoardElements[0],
				ctaDivRect = ctaDiv.getBoundingClientRect();
				//productDiv = ctaDiv ? ctaDiv.parentElement.parentElement : null;

			let productDiv = ctaDiv ? ctaDiv.parentElement.parentElement : null,
				productDivIsDestination = false;
			if(ctaDiv.classList.contains("js-destination")){
				productDiv = ctaDiv.parentElement.parentElement.parentElement;
				productDivIsDestination = true;
			}

			const productDivIsSwiper = productDiv.classList.contains("swiper-slide"),
				productDivRect = productDiv.getBoundingClientRect(),
				productTopContainer = productDiv.parentElement.parentElement.getBoundingClientRect().left > 0 ? productDiv.parentElement.parentElement : productDiv.parentElement,
				quickModalSearch = document.getElementsByClassName('js-travel-board-quick-modal'),
				quickModal = quickModalSearch ? quickModalSearch[0] : null,
				quickModalContent = quickModal ? quickModal.getElementsByClassName('modal-content')[0] as HTMLElement : null,
				quickLeftSpacer = 8,
				quickLeftSwiper =  productDivRect.left - productTopContainer.getBoundingClientRect().left + quickLeftSpacer,//need for swiper
				quickLeftCtaOnly =  ctaDivRect.left - ctaDiv.parentElement.parentElement.parentElement.getBoundingClientRect().left,//for no swiper
				quickTop = productDivRect.top + productDivRect.height - 40;

			let quickLeft = (productDivIsSwiper || productDivIsDestination) ? quickLeftSwiper : quickLeftCtaOnly,
				quickLeftPlusWidth = quickLeft + quickModalContent.getBoundingClientRect().width;

			//TODO-JK: add more logic to check if the modal is offscreen for mobile/tablet

			if(quickLeftPlusWidth > window.innerWidth - 100) {
				quickLeft -= quickModalContent.getBoundingClientRect().width;
			}

			if(_log) console.group('ctaDiv');
			if(_log) console.log('ctaDiv', ctaDiv);
			if(_log) console.log('destinations.cardx4up', ctaDiv.parentElement.parentElement.parentElement.getBoundingClientRect().left);
			if(_log) console.log('destinations.cardx4up.parentElement', ctaDiv.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect().left);
			if(_log) console.log('destinations', ctaDiv.parentElement.parentElement.parentElement.getBoundingClientRect().left);
			if(_log) console.log('ctaDivRect.left', ctaDivRect.left);
			if(_log) console.log('productDivIsSwiper', productDivIsSwiper);
			if(_log) console.log('productDivRect', productDivRect);
			if(_log) console.log('ctaDivRect', ctaDivRect);
			if(_log) console.log('productDiv.parentElement.parentElement', productDiv.parentElement.parentElement.getBoundingClientRect().left);
			if(_log) console.log('productDiv.parentElement', productDiv.parentElement.getBoundingClientRect().left);
			if(_log) console.log('productTopContainer', productTopContainer.getBoundingClientRect().left);
			if(_log) console.log('quickLeftSwiper', quickLeftSwiper);
			if(_log) console.log('quickLeftCtaOnly', quickLeftCtaOnly);
			if(_log) console.log('quickModalContent', quickModalContent);
			if(_log) console.log('quickLeft', productDivRect.left, quickLeftSpacer, '=', quickLeft);
			if(_log) console.log('quickLeftPlusWidth', quickLeftPlusWidth, 'vs', window.innerWidth);
			if(_log) console.groupEnd();
		
			//position quick modal
			quickModalContent.style.position = 'absolute';
			quickModalContent.style.left = quickLeft + 'px';
			quickModalContent.style.top = quickTop + 'px';
		}
		
	}



	/**
	 * Open Choose Board modal
	 * @param productId 
	*/
	public onChooseBoard(productId: string) {
		//console.log('TravelBoardComponent.onChooseBoard.productId:', productId);

		this.modalRef?.hide();

		//modal model
		const initialState = {
			productId: productId,
			//currentBoard: 'Some-Board-123'
		};

		//modal config
		this.modalRef = this.modalService.show(TravelBoardChooserComponent, {
			initialState, 
			animated: false, 
			backdrop: true,
			class: 'travel-board-chooser-modal js-travel-board-chooser-modal'
		});

		(this.modalRef.content as TravelBoardQuickComponent).selectBoard.subscribe(data=> {
			//console.log('TravelBoardComponent.onChooseBoard.selectBoard', data);
			//hit select endpoint
			this.addProductToBoard(data.productId, data.board);
		});

		(this.modalRef.content as TravelBoardQuickComponent).createBoard.subscribe(data=> {
			//console.log('TravelBoardComponent.onChooseBoard.createBoard', data);
			//open create modal
			setTimeout(() => {
				this.onEditBoard(data.productId);
			}, 2);
		});

	}




	/**
	 * Update Board with new Product Id
	 * Excursion Itinerary
	 * @param productId 
	 * @param board 
	*/
	public addProductToBoard(productId: string, board: ExcursionItinerary) {
		//console.log('TravelBoardComponent.addProductToBoard', productId, board);

		if(!board || !board.id) {
			setTimeout(() => {
				this.onChooseBoard(productId);
			}, 2);
			return;
		}

		let updatedBoard = JSON.parse(JSON.stringify(board));//clone board
		if(!updatedBoard.products)updatedBoard.products = [];

		if(!updatedBoard.cruiseInformation) {
			//TODO-JK: come back and remove this once Casidy updates API
			updatedBoard.cruiseInformation = {
				cruiseLine: '',
				shipName: '',
				departureDate: dayjs().format('YYYY-MM-DD'),
				codeToCruiseId: 0,
			};
		}


		const findProduct = updatedBoard.products.find(x => x.productId == productId);
		//console.log('findProduct:', findProduct);
		
		if(findProduct){
			//console.log('product is already in that travel board.');
			this.modalRef?.hide();
			
			setTimeout(() => {
				this.onDisplayMessage({success: 'That excursion is already in that travel board.'}, updatedBoard);
			}, 20);
			return;
		}
		
		updatedBoard.products.push({
			excursionItineraryId: board.id,
			productId: productId
		});
		//console.log('updatedBoard:', updatedBoard);

		this._compassAPIExcursionItineraryService.putExcursionItineraries(board.id, updatedBoard)
			.pipe(first())
			.subscribe((res: any) => {
				console.log('TravelBoardComponent.putExcursionItineraries.res', res);
				if(!res.error) {
					//do something
					this.modalRef?.hide();
					setTimeout(() => {
						this.onDisplayMessage({success: 'Excursion successfully added to travel board.'}, updatedBoard);
					}, 20);
					
				}
			});
	}
	






	/**
	 * Open Create/Edit Board modal
	 * @param productId 
	*/
	public onEditBoard(productId: string, board: ExcursionItinerary = null) {
		//console.log('TravelBoardComponent.onEditBoard.productId:', productId);

		this.modalRef?.hide();

		//modal model
		const initialState = {
			productId: productId,
			board: board
		};

		//modal config
		this.modalRef = this.modalService.show(TravelBoardEditComponent, {
			initialState, 
			animated: false, 
			backdrop: true,
			class: 'travel-board-edit-modal js-travel-board-edit-modal'
		});

		// (this.modalRef.content as TravelBoardQuickComponent).selectBoard.subscribe(data=> {
		// 	console.log('TravelBoardComponent.onEditBoard.selectBoard', data);
		// 	//hit select endpoint
		// 	//this.addProductToBoard(data.productId, data.board);
		// });

	}




	public onDisplayMessage(responseMsg: ResponseMessage, board: ExcursionItinerary = null) {
		this.modalRef?.hide();
		
		//console.log('onDisplayMessage.responseMsg:', responseMsg);

		//modal model
		const initialState = {
			//test: 'asdf',
			responseMsg: responseMsg,
			board: board
		};

		//modal config
		this.modalRef = this.modalService.show(TravelBoardResponseComponent, {
			initialState, 
			animated: false, 
			backdrop: true,
			class: 'travel-board-response-modal js-travel-board-response-modal'
		});

		setTimeout(() => {
			this.modalRef?.hide();
		}, 3000);

	}

	

}
